/**
 * Long-form copy for /services/companies.
 * To add a language: extend each field below and register in locales/index.js.
 */
export const companyServicesByLocale = {
  de: {
    intro:
      "Für Wirtschaftsunternehmen, die bereits Sportsponsoring betreiben, bieten wir Maßnahmen zur Analyse, Kontrolle und Optimierung ihrer Sponsoringkonzepte und der korrespondierenden Projekte sowie projektflankierende Maßnahmen an; für Wirtschaftsunternehmen, die den Eintritt in den Bereich des Sportsponsorings planen, bieten wir Marktforschung und Konzeptentwicklung an.",
    sections: [
      {
        type: "text",
        h2: "Sportsponsoringkonzepte",
        body: "Entwicklung von Sportsponsoringkonzepten auf der Grundlage von Marktforschung und zur Ansprache von Zielgruppen, Beratung beim Erwerb von Sportsponsoringrechten",
      },
      {
        type: "list",
        h2: "Marktforschung, Controlling, Audits und SWOT-Analysen bei Sportsponsoringprojekten",
        items: [
          "TV-Quoten, TV-Seherstrukturanalysen, Medien- und Zuschaueranalysen",
          "TKP- und Werbewert- und Werbeäquivalenzwertberechnungen",
          "Overnight-Analysen, Pre-Event-Analysen, Zielgruppenanalysen",
          "Printmedien- und Internetanalysen, TV-Programmüberwachungen",
          '"label-on-screen-Messungen", Werbebotschaftsanalysen',
          "Visibilitätsoptimierung bei Werbeflächen und Logos",
          "PR-Clipping und Alerting, Imageanalysen",
          "Optimierung von Sponsoringinstrumenten",
          "Event-Impact-Analysen, Cross-Media-Research",
          "Fan-Feedback, Brandtracking",
        ],
      },
      {
        type: "text",
        h2: "Sportsponsoringflankierende Maßnahmen",
        body: "Projektflankierende PR mit Generierung von Botschaften, zielgruppenspezifischer Mediensegmentierung, Entwicklung von Formaten und Inhalten (Reportagen, Interviews, Kolumnen), Durchführung der Redaktionsansprachen und Projekt-Controlling; Planung und Durchführung von projektflankierenden Events und Incentives, Key-Speaker-Vermittlung bezogen auf Persönlichkeiten des Sports und der Sportökonomie",
      },
      {
        type: "text",
        h2: "Scouting und Akquisition von nationalen/internationalen Sportlern für Sponsoringkonzepte",
        body: "Identifikation von Sportlern nach Profilanforderung, Anbahnungsgespräche, Vertragsverhandlungen, Preisberatung, Betreuung",
      },
    ],
  },
  en: {
    intro:
      "For companies already engaged in sports sponsorship, we offer measures for analyzing, controlling, and optimizing their sponsorship concepts and corresponding projects, as well as project-supporting measures; for companies planning to enter the field of sports sponsorship, we offer market research and concept development.",
    sections: [
      {
        type: "text",
        h2: "Sports Sponsorship Concepts",
        body: "Development of sports sponsorship concepts based on market research and targeting specific audiences, consulting on the acquisition of sports sponsorship rights",
      },
      {
        type: "list",
        h2: "Market Research, Controlling, Audits and SWOT Analyses for Sports Sponsorship Projects",
        items: [
          "TV ratings, TV viewer structure analyses, media and audience analyses",
          "CPM and advertising value and advertising equivalence value calculations",
          "Overnight analyses, pre-event analyses, target group analyses",
          "Print media and internet analyses, TV program monitoring",
          '"Label-on-screen measurements", advertising message analyses',
          "Visibility optimization for advertising spaces and logos",
          "PR clipping and alerting, image analyses",
          "Optimization of sponsorship instruments",
          "Event impact analyses, cross-media research",
          "Fan feedback, brand tracking",
        ],
      },
      {
        type: "text",
        h2: "Sports Sponsorship Supporting Measures",
        body: "Project-supporting PR with message generation, target group-specific media segmentation, development of formats and content (reports, interviews, columns), conducting editorial approaches and project controlling; planning and execution of project-supporting events and incentives, key speaker mediation related to personalities in sports and sports economics",
      },
      {
        type: "text",
        h2: "Scouting and Acquisition of National/International Athletes for Sponsorship Concepts",
        body: "Identification of athletes according to profile requirements, initial discussions, contract negotiations, price consulting, support",
      },
    ],
  },
  fr: {
    intro:
      "Pour les entreprises qui pratiquent déjà le sponsoring sportif, nous proposons des mesures d’analyse, de contrôle et d’optimisation de leurs concepts de sponsoring et des projets correspondants, ainsi que des mesures d’accompagnement ; pour celles qui envisagent d’entrer dans le sponsoring sportif, nous proposons des études de marché et l’élaboration de concepts.",
    sections: [
      {
        type: "text",
        h2: "Concepts de sponsoring sportif",
        body: "Élaboration de concepts de sponsoring sportif sur la base d’études de marché et de ciblage d’audiences, conseil pour l’acquisition de droits de sponsoring sportif",
      },
      {
        type: "list",
        h2: "Études de marché, controlling, audits et analyses SWOT pour projets de sponsoring sportif",
        items: [
          "Audiences TV, analyses de structure des téléspectateurs, analyses médias et publics",
          "Calculs CPM, valeur publicitaire et équivalence publicitaire",
          "Analyses overnight, pré-événement, groupes cibles",
          "Analyses presse et internet, surveillance des programmes TV",
          "Mesures « label-on-screen », analyses des messages publicitaires",
          "Optimisation de la visibilité des espaces et logos",
          "Veille RP et alertes, analyses d’image",
          "Optimisation des instruments de sponsoring",
          "Analyses d’impact d’événements, recherche cross-média",
          "Retours fans, suivi de marque",
        ],
      },
      {
        type: "text",
        h2: "Mesures complémentaires au sponsoring sportif",
        body: "RP d’accompagnement de projet avec génération de messages, segmentation média par cible, développement de formats et contenus (reportages, interviews, chroniques), approches rédactionnelles et controlling de projet ; planification et réalisation d’événements et d’incentives d’accompagnement, médiation d’intervenants clés liés aux personnalités du sport et de l’économie du sport",
      },
      {
        type: "text",
        h2: "Scouting et acquisition d’athlètes nationaux/internationaux pour concepts de sponsoring",
        body: "Identification d’athlètes selon le profil requis, premiers entretiens, négociations contractuelles, conseil tarifaire, accompagnement",
      },
    ],
  },
  es: {
    intro:
      "Para empresas que ya realizan patrocinio deportivo ofrecemos medidas de análisis, control y optimización de sus conceptos de patrocinio y de los proyectos correspondientes, así como medidas de apoyo; para empresas que planean entrar en el patrocinio deportivo ofrecemos estudios de mercado y desarrollo de conceptos.",
    sections: [
      {
        type: "text",
        h2: "Conceptos de patrocinio deportivo",
        body: "Desarrollo de conceptos de patrocinio deportivo basados en estudios de mercado y en la definición de públicos objetivo, asesoramiento en la adquisición de derechos de patrocinio deportivo",
      },
      {
        type: "list",
        h2: "Investigación de mercado, controlling, auditorías y análisis FODA en proyectos de patrocinio deportivo",
        items: [
          "Audiencias de TV, análisis de estructura de espectadores, análisis de medios y público",
          "Cálculos de CPM, valor publicitario y equivalencia publicitaria",
          "Análisis overnight, pre-evento, grupos objetivo",
          "Análisis de prensa e internet, monitorización de programas de TV",
          "Mediciones «label-on-screen», análisis de mensajes publicitarios",
          "Optimización de la visibilidad de espacios y logotipos",
          "Clipping y alertas de RR.PP., análisis de imagen",
          "Optimización de instrumentos de patrocinio",
          "Análisis de impacto de eventos, investigación cross-media",
          "Feedback de aficionados, seguimiento de marca",
        ],
      },
      {
        type: "text",
        h2: "Medidas de apoyo al patrocinio deportivo",
        body: "RR.PP. de apoyo al proyecto con generación de mensajes, segmentación mediática por grupos objetivo, desarrollo de formatos y contenidos (reportajes, entrevistas, columnas), enfoques editoriales y controlling del proyecto; planificación y ejecución de eventos e incentivos de apoyo, mediación de ponentes clave vinculados a personalidades del deporte y de la economía del deporte",
      },
      {
        type: "text",
        h2: "Scouting y adquisición de deportistas nacionales/internacionales para conceptos de patrocinio",
        body: "Identificación de deportistas según requisitos de perfil, conversaciones iniciales, negociación contractual, asesoramiento de precios, acompañamiento",
      },
    ],
  },
};

export function getCompanyServicesCopy(locale) {
  return companyServicesByLocale[locale] || companyServicesByLocale.en;
}
